<template>
  <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 0.850098C4.67 0.850098 0.75 4.7701 0.75 9.6001C0.75 14.4301 4.67 18.3501 9.5 18.3501C14.33 18.3501 18.25 14.4301 18.25 9.6001C18.25 4.7701 14.33 0.850098 9.5 0.850098ZM8.625 13.975V12.225H10.375V13.975H8.625ZM8.625 5.225V10.475H10.375V5.225H8.625Z"
      fill="#C2002F"/>
  </svg>
</template>
